module.exports = __webpack_public_path__ + "static/img/12.70ecaa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/huegler/12.jpg
// module id = 386
// module chunks = 1